/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";
import {
  SearchToolCallsFilter,
  SearchToolCallsFilter$Outbound,
  SearchToolCallsFilter$outboundSchema,
} from "./searchtoolcallsfilter.js";

/**
 * Sort order
 */
export const SearchToolCallsPayloadSort = {
  Asc: "asc",
  Desc: "desc",
} as const;
/**
 * Sort order
 */
export type SearchToolCallsPayloadSort = ClosedEnum<
  typeof SearchToolCallsPayloadSort
>;

/**
 * Payload for searching tool call summaries
 */
export type SearchToolCallsPayload = {
  /**
   * Cursor for pagination
   */
  cursor?: string | undefined;
  /**
   * Filter criteria for searching tool calls
   */
  filter?: SearchToolCallsFilter | undefined;
  /**
   * Number of items to return (1-1000)
   */
  limit?: number | undefined;
  /**
   * Sort order
   */
  sort?: SearchToolCallsPayloadSort | undefined;
};

/** @internal */
export const SearchToolCallsPayloadSort$outboundSchema: z.ZodMiniEnum<
  typeof SearchToolCallsPayloadSort
> = z.enum(SearchToolCallsPayloadSort);

/** @internal */
export type SearchToolCallsPayload$Outbound = {
  cursor?: string | undefined;
  filter?: SearchToolCallsFilter$Outbound | undefined;
  limit: number;
  sort: string;
};

/** @internal */
export const SearchToolCallsPayload$outboundSchema: z.ZodMiniType<
  SearchToolCallsPayload$Outbound,
  SearchToolCallsPayload
> = z.object({
  cursor: z.optional(z.string()),
  filter: z.optional(SearchToolCallsFilter$outboundSchema),
  limit: z._default(z.int(), 50),
  sort: z._default(SearchToolCallsPayloadSort$outboundSchema, "desc"),
});

export function searchToolCallsPayloadToJSON(
  searchToolCallsPayload: SearchToolCallsPayload,
): string {
  return JSON.stringify(
    SearchToolCallsPayload$outboundSchema.parse(searchToolCallsPayload),
  );
}
